module.exports = __webpack_public_path__ + "thumbs_up.svg?46dcaa650c94a49e32e88316d5290066";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reactions/thumbs_up.svg
// module id = 92
// module chunks = 0